
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-1dd4c242\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./About.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./About.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1dd4c242\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./About.vue"),
  /* scopeId */
  "data-v-1dd4c242",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/About.vue
// module id = 35
// module chunks = 0